package com.starparty.app.astro0.renderers

import com.starparty.app.astro0.*
import com.starparty.app.geometry.SP_Point

class SkyRenderer constructor(val itsSky:Sky) {

    protected var mLastAdjPoint = SP_Point()
    protected var itsBGCol = SP_Colour(0,0,0,255) // BLACK
    protected var itsBelowHorizonCol = SP_Colour(255, 20, 20, 20)
    protected var itsEquGridColor = SP_Colour(120, 120, 120, 120)
    protected var itsEquZeroGridColor = SP_Colour(120, 200, 200, 200)
    protected var itsAltAzmGridColor = SP_Colour(0, 255, 255, 120)
    protected var itsAltAzmZeroGridColor = SP_Colour(0,255,255,200) //CYAN
    protected var itsEquatorColor = SP_Colour(255,255,255,255)
    protected var itsHorizonColor = SP_Colour(0,255,0, 255) //GREEN
    protected var m_altAzmGridLabelColor = SP_Colour(255,255,255,255) // WHITE
  //  private val m_scaleGestureDetector: ScaleGestureDetector
    protected var gridLabelTextSize = 20.0f
    protected var gridLabelColour = SP_Colour(255, 255, 255, 255)

    val starDataURL = "resources/sorted_stars.dat"
    val conDataURL = "resources/constellations.dat"

    val DEF_INCREMENT = 2500.0
    val MAX_INCREMENT = 5.0
    val DEF_LATITUDE: Double = UMS.Companion.unitMinSecToDecimal("50 4 40")
    val DEF_LONGITUDE: Double = UMS.Companion.unitMinSecToDecimal("5 42 12")
    protected var itsIncrement = 0.0
    protected var itsRollIncrement = 5.0
    protected var itsOffsetIncrement = 5
    protected var itsZoomIncrement = 0.95

    fun onDraw(canvas: SP_Canvas,
               paint: SP_Paint) {

        canvas.drawColor(itsBGCol)

        paintGrids(canvas, paint)
        DSOFieldRenderer.paint(itsSky.deepSkyField, itsSky.showLabels, canvas, paint)
        StarFieldRenderer.paint(itsSky.starField, itsSky.showLabels, canvas, paint)
        OrreryRenderer.paint(itsSky.orrery, itsSky.showLabels, canvas, paint)
    }

    private enum class State {
        NONE, DRAG, ZOOM
    }

    private var state =
        State.NONE
    private val last = SP_Point()
    private fun setState(state: State) {
        this.state = state
    }

    protected fun paintGrids(g: SP_Canvas,
                             paint: SP_Paint) {
        val altAzmGridType = itsSky.showAltAzmGridType
        if (altAzmGridType == Sky.FULL_GRID || altAzmGridType == Sky.BOTH_GRIDS) {
            paint.setColour(itsAltAzmGridColor)
            GridRenderer.paintWholeGrid(itsSky.altAzmGrid, g, paint)
        }
        if (altAzmGridType == Sky.ZERO_GRID || altAzmGridType == Sky.BOTH_GRIDS) {
            paint.setColour(itsAltAzmZeroGridColor)
            //paint.style = Paint.Style.FILL
          //  paint.color = itsBelowHorizonCol
          //  GridRenderer.paintSolidCircle(
          //      itsSky.altAzmZeroGrid.latLines[0],
          //      g,
          //      mPaint
          //  )
            //paint.style = Paint.Style.STROKE
            paint.setColour(itsAltAzmZeroGridColor)
            GridRenderer.paintAllLongitudeLines(itsSky.altAzmZeroGrid, g, paint)
            paint.setColour(itsHorizonColor)
            GridRenderer.paintAllLatitudeLines(itsSky.altAzmZeroGrid, g, paint)
        }
        val equGridType = itsSky.showEquGridType
        if (equGridType == Sky.FULL_GRID || equGridType == Sky.BOTH_GRIDS) {
            paint.setColour(itsEquGridColor)
            GridRenderer.paintWholeGrid(itsSky.equGrid, g, paint)
        }
        if (equGridType == Sky.ZERO_GRID || equGridType == Sky.BOTH_GRIDS) {
            paint.setColour(itsEquZeroGridColor)
            GridRenderer.paintAllLongitudeLines(itsSky.equZeroGrid, g, paint)
            paint.setColour(itsEquatorColor)
            GridRenderer.paintAllLatitudeLines(itsSky.equZeroGrid, g, paint)
        }

        if (itsSky.showLabels > 0) {
            paintGridLabels(g, paint)
        }
    }

    protected fun paintGridLabels(g: SP_Canvas,
                                  paint: SP_Paint) {
        var point = itsSky.zenith
        var label = GridRenderer.ZENITH_LABEL
        paint.setTextSize(gridLabelTextSize)
        paint.setColour(gridLabelColour)

        TextRenderer.paintLabel(
            g,
            paint,
            point,
            label
        )
        point = itsSky.nadir
        label = GridRenderer.NADIR_LABEL
        TextRenderer.paintLabel(
            g,
            paint,
            point,
            label
        )
        point = itsSky.north
        label = GridRenderer.N_LABEL
        TextRenderer.paintLabel(
            g,
            paint,
            point,
            label
        )
        point = itsSky.south
        label = GridRenderer.S_LABEL
        TextRenderer.paintLabel(
            g,
            paint,
            point,
            label
        )
        point = itsSky.east
        label = GridRenderer.E_LABEL
        TextRenderer.paintLabel(
            g,
            paint,
            point,
            label
        )
        point = itsSky.west
        label = GridRenderer.W_LABEL
        TextRenderer.paintLabel(
            g,
            paint,
            point,
            label
        )
    }



    init {
        val starDataURL = starDataURL
        val conDataURL = conDataURL
      //  val starsId = R.raw.stars
      //  val constellationsId = R.raw.constellations
        //InputStream starsIS = context.getResources().openRawResource(starsId);
        //InputStream constellationsIS = context.getResources().openRawResource(constellationsId);
        //   resetIncrement();


        // setBackground(Color.blue);
        itsSky.project()

        //  setToolTipText("");
        //  ToolTipManager.sharedInstance().setDismissDelay(Time.MINS_TO_MS);
        itsSky.centerPoint = itsSky.centerPoint
    //    m_scaleGestureDetector = ScaleGestureDetector(context, ScaleListener())
    }
}